import { useTranslation } from 'react-i18next'
import { ChevronRight, Home } from 'lucide-react'

export default function GroupBreadcrumb({ path, onNavigate }) {
  const { t } = useTranslation()
  // path = array de { id, name } - caminho do nível raiz até o atual
  // onNavigate(null) = vai para raiz; onNavigate(id) = vai para grupo

  return (
    <nav className="flex items-center gap-1 text-sm text-gray-500 flex-wrap">
      <button
        onClick={() => onNavigate(null)}
        className="flex items-center gap-1 hover:text-gray-800 transition-colors"
      >
        <Home className="w-3.5 h-3.5" />
        <span>{t('groups.breadcrumbRoot')}</span>
      </button>

      {path.map((item) => (
        <span key={item.id} className="flex items-center gap-1">
          <ChevronRight className="w-3.5 h-3.5 text-gray-300" />
          <button
            onClick={() => onNavigate(item.id)}
            className="hover:text-gray-800 transition-colors font-medium"
          >
            {item.name}
          </button>
        </span>
      ))}
    </nav>
  )
}
